
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/// <reference types="w3c-web-usb" />
const $b721319b8fa56275$export$722479723a3a439b = [
    {
        name: 'field.deviceName.name',
        type: 'text',
        register: 'DEVICE_NAME',
        defaultValue: 'USB Device 1',
        placeholder: 'field.deviceName.placeholder',
        help: 'field.deviceName.help'
    },
    {
        name: 'field.baudRate.name',
        type: 'select',
        register: 'BAUD_RATE',
        options: [
            {
                label: 'field.baudRate.option.9600',
                value: 9600
            },
            {
                label: 'field.baudRate.option.19200',
                value: 19200
            },
            {
                label: 'field.baudRate.option.38400',
                value: 38400
            },
            {
                label: 'field.baudRate.option.57600',
                value: 57600
            },
            {
                label: 'field.baudRate.option.115200',
                value: 115200
            }
        ],
        defaultValue: 38400,
        help: 'field.baudRate.help'
    },
    {
        name: 'field.timeout.name',
        type: 'number',
        register: 'TIMEOUT',
        min: 1000,
        max: 30000,
        step: 500,
        defaultValue: 5000,
        help: 'field.timeout.help'
    },
    {
        name: 'field.autoReconnect.name',
        type: 'checkbox',
        register: 'AUTO_RECONNECT',
        defaultValue: true,
        help: 'field.autoReconnect.help'
    },
    {
        name: 'field.retryCount.name',
        type: 'number',
        register: 'RETRY_COUNT',
        min: 0,
        max: 10,
        step: 1,
        defaultValue: 3,
        help: 'field.retryCount.help'
    },
    {
        name: 'field.logLevel.name',
        type: 'select',
        register: 'LOG_LEVEL',
        options: [
            {
                label: 'field.logLevel.option.debug',
                value: 'debug'
            },
            {
                label: 'field.logLevel.option.info',
                value: 'info'
            },
            {
                label: 'field.logLevel.option.warning',
                value: 'warning'
            },
            {
                label: 'field.logLevel.option.error',
                value: 'error'
            }
        ],
        defaultValue: 'info',
        help: 'field.logLevel.help'
    }
];


function $0266756030f09424$export$62b110e0dc0699c4() {
    return (0, $b721319b8fa56275$export$722479723a3a439b).reduce((acc, field)=>{
        if (field.defaultValue !== undefined) acc.set(field.register, field.defaultValue);
        return acc;
    }, new Map());
}
function $0266756030f09424$export$a5bc101ffe200192(config) {
    const commands = [
        '# Configuration generated at ' + new Date().toISOString()
    ];
    config.forEach((value, register)=>{
        const formattedValue = $0266756030f09424$var$formatValue(value);
        commands.push(`SET_REGISTER ${register} ${formattedValue}`);
    });
    commands.push('APPLY_CONFIG');
    return commands;
}
/**
 * Formats a value for CLI transmission
 */ function $0266756030f09424$var$formatValue(value) {
    if (typeof value === 'boolean') return value ? '1' : '0';
    return String(value);
}
function $0266756030f09424$export$2d002c582c9ee89e(config) {
    return $0266756030f09424$export$a5bc101ffe200192(config).join('\n');
}
function $0266756030f09424$export$eadcbbf7a0bcdc91(text) {
    const lines = text.split('\n').filter((line)=>line.trim() && !line.startsWith('#'));
    return lines.reduce((acc, line)=>{
        const match = line.match(/^SET_REGISTER\s+(\S+)\s+(.+)$/);
        if (match) {
            const [, register, valueStr] = match;
            const value = $0266756030f09424$var$parseValue(valueStr);
            acc.set(register, value);
        }
        return acc;
    }, new Map());
}
/**
 * Parse a string value back to ConfigValue
 */ function $0266756030f09424$var$parseValue(value) {
    if (value === '1') return true;
    if (value === '0') return false;
    const num = Number(value);
    return Number.isNaN(num) ? value : num;
}




function $0621848b4c472bdf$export$5303528d1070ff6f(value, type) {
    switch(type){
        case 'number':
            return Number(value);
        case 'checkbox':
            return value === 'true';
        default:
            return value;
    }
}
function $0621848b4c472bdf$export$cec8daecec400388(app, fieldId, value) {
    const fieldConfig = (0, $b721319b8fa56275$export$722479723a3a439b).find((f)=>f.register === fieldId);
    if (fieldConfig) {
        const typedValue = $0621848b4c472bdf$export$5303528d1070ff6f(value, fieldConfig.type);
        return {
            ...app,
            config: new Map(app.config).set(fieldConfig.register, typedValue)
        };
    }
    return app;
}


/**
* https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
* with some tweaks
*/ const $0d541ce8956791f4$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $0d541ce8956791f4$export$f7b99fb377fe69fa(skeleton) {
    const result = {};
    skeleton.replace($0d541ce8956791f4$var$DATE_TIME_REGEX, (match)=>{
        const len = match.length;
        switch(match[0]){
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}


// @generated from regex-gen.ts
const $0e5d9ef77b70e9a5$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $0b4d7b961c3a6f72$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    const stringTokens = skeleton.split((0, $0e5d9ef77b70e9a5$export$2b8db14d8bcaece7)).filter((x)=>x.length > 0);
    const tokens = [];
    for (const stringToken of stringTokens){
        let stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        const [stem, ...options] = stemAndOptions;
        for (const option of options){
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $0b4d7b961c3a6f72$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
const $0b4d7b961c3a6f72$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
const $0b4d7b961c3a6f72$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
const $0b4d7b961c3a6f72$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
const $0b4d7b961c3a6f72$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $0b4d7b961c3a6f72$var$parseSignificantPrecision(str) {
    const result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($0b4d7b961c3a6f72$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $0b4d7b961c3a6f72$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $0b4d7b961c3a6f72$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    let result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        const signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$0b4d7b961c3a6f72$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $0b4d7b961c3a6f72$var$parseNotationOptions(opt) {
    const result = {};
    const signOpts = $0b4d7b961c3a6f72$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $0b4d7b961c3a6f72$export$47c6f8480bda3e11(tokens) {
    let result = {};
    for (const token of tokens){
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $0b4d7b961c3a6f72$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = {
                    ...result,
                    notation: "scientific",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$0b4d7b961c3a6f72$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "engineering":
                result = {
                    ...result,
                    notation: "engineering",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$0b4d7b961c3a6f72$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($0b4d7b961c3a6f72$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($0b4d7b961c3a6f72$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($0b4d7b961c3a6f72$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($0b4d7b961c3a6f72$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            const opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = {
                ...result,
                trailingZeroDisplay: "stripIfInteger"
            };
            else if (opt) result = {
                ...result,
                ...$0b4d7b961c3a6f72$var$parseSignificantPrecision(opt)
            };
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($0b4d7b961c3a6f72$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = {
                ...result,
                ...$0b4d7b961c3a6f72$var$parseSignificantPrecision(token.stem)
            };
            continue;
        }
        const signOpts = $0b4d7b961c3a6f72$var$parseSign(token.stem);
        if (signOpts) result = {
            ...result,
            ...signOpts
        };
        const conciseScientificAndEngineeringOpts = $0b4d7b961c3a6f72$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = {
            ...result,
            ...conciseScientificAndEngineeringOpts
        };
    }
    return result;
}




let $08f109f7ae08cdee$export$b87f371cbc396fcf = /* @__PURE__ */ function(TYPE) {
    /**
	* Raw text
	*/ TYPE[TYPE["literal"] = 0] = "literal";
    /**
	* Variable w/o any format, e.g `var` in `this is a {var}`
	*/ TYPE[TYPE["argument"] = 1] = "argument";
    /**
	* Variable w/ number format
	*/ TYPE[TYPE["number"] = 2] = "number";
    /**
	* Variable w/ date format
	*/ TYPE[TYPE["date"] = 3] = "date";
    /**
	* Variable w/ time format
	*/ TYPE[TYPE["time"] = 4] = "time";
    /**
	* Variable w/ select format
	*/ TYPE[TYPE["select"] = 5] = "select";
    /**
	* Variable w/ plural format
	*/ TYPE[TYPE["plural"] = 6] = "plural";
    /**
	* Only possible within plural argument.
	* This is the `#` symbol that will be substituted with the count.
	*/ TYPE[TYPE["pound"] = 7] = "pound";
    /**
	* XML-like tag
	*/ TYPE[TYPE["tag"] = 8] = "tag";
    return TYPE;
}({});
let $08f109f7ae08cdee$export$906452485466fa53 = /* @__PURE__ */ function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
    return SKELETON_TYPE;
}({});
function $08f109f7ae08cdee$export$cfa10c5697238752(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.literal;
}
function $08f109f7ae08cdee$export$4f55724281bdfaf9(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.argument;
}
function $08f109f7ae08cdee$export$e11187b219e191e1(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.number;
}
function $08f109f7ae08cdee$export$32d811605da75f40(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.date;
}
function $08f109f7ae08cdee$export$34ec46f596b1702f(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.time;
}
function $08f109f7ae08cdee$export$dcfe1c11d168b5a1(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.select;
}
function $08f109f7ae08cdee$export$6c796d116f0a4fbc(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.plural;
}
function $08f109f7ae08cdee$export$c0ece297bdd0c082(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.pound;
}
function $08f109f7ae08cdee$export$5c83de34745812b(el) {
    return el.type === $08f109f7ae08cdee$export$b87f371cbc396fcf.tag;
}
function $08f109f7ae08cdee$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $08f109f7ae08cdee$export$906452485466fa53.number);
}
function $08f109f7ae08cdee$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $08f109f7ae08cdee$export$906452485466fa53.dateTime);
}
function $08f109f7ae08cdee$export$f0ac572c1121c662(value) {
    return {
        type: $08f109f7ae08cdee$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $08f109f7ae08cdee$export$425e864b0ba114f1(value, style) {
    return {
        type: $08f109f7ae08cdee$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


let $bfc08167ad7a6652$export$896afd8541959ee5 = /* @__PURE__ */ function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
	* Expecting a message fragment after the `plural` or `selectordinal` selector
	* (e.g. `{foo, plural, one}`)
	*/ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
	* Duplicate selectors in `plural` or `selectordinal` argument.
	* (e.g. {foo, plural, one {#} one {#}})
	*/ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
	* (e.g. {foo, select, apple {apple} apple {apple}})
	*/ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
    return ErrorKind;
}({});




// @generated from regex-gen.ts
const $c2c7dd4847171b5f$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
const $c2c7dd4847171b5f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;



// @generated from time-data-gen.ts
// prettier-ignore
const $5e9c7dbe251ae20f$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ku-SY": [
        "H",
        "hB"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $e6e26a908bd84906$export$29c5368be8904d27(skeleton, locale) {
    let skeletonCopy = "";
    for(let patternPos = 0; patternPos < skeleton.length; patternPos++){
        const patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            let extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            let hourLen = 1 + (extraLength & 1);
            let dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            let dayPeriodChar = "a";
            let hourChar = $e6e26a908bd84906$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
* Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
* of the given `locale` to the corresponding time pattern.
* @param locale
*/ function $e6e26a908bd84906$var$getDefaultHourSymbolFromLocale(locale) {
    let hourCycle = locale.hourCycle;
    if (hourCycle === undefined && locale.hourCycles && locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    const languageTag = locale.language;
    let regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    const hourCycles = (0, $5e9c7dbe251ae20f$export$a8c9209db4084317)[regionTag || ""] || (0, $5e9c7dbe251ae20f$export$a8c9209db4084317)[languageTag || ""] || (0, $5e9c7dbe251ae20f$export$a8c9209db4084317)[`${languageTag}-001`] || (0, $5e9c7dbe251ae20f$export$a8c9209db4084317)["001"];
    return hourCycles[0];
}


const $45586c55517d4888$var$SPACE_SEPARATOR_START_REGEX = new RegExp(`^${(0, $c2c7dd4847171b5f$export$523451f94304dd6c).source}*`);
const $45586c55517d4888$var$SPACE_SEPARATOR_END_REGEX = new RegExp(`${(0, $c2c7dd4847171b5f$export$523451f94304dd6c).source}*$`);
function $45586c55517d4888$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
const $45586c55517d4888$var$hasNativeFromEntries = !!Object.fromEntries;
const $45586c55517d4888$var$hasTrimStart = !!String.prototype.trimStart;
const $45586c55517d4888$var$hasTrimEnd = !!String.prototype.trimEnd;
const $45586c55517d4888$var$fromEntries = $45586c55517d4888$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    const obj = {};
    for (const [k, v] of entries)obj[k] = v;
    return obj;
};
const $45586c55517d4888$var$trimStart = $45586c55517d4888$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($45586c55517d4888$var$SPACE_SEPARATOR_START_REGEX, "");
};
const $45586c55517d4888$var$trimEnd = $45586c55517d4888$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($45586c55517d4888$var$SPACE_SEPARATOR_END_REGEX, "");
};
// #endregion
const $45586c55517d4888$var$IDENTIFIER_PREFIX_RE = new RegExp("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
function $45586c55517d4888$var$matchIdentifierAtIndex(s, index) {
    $45586c55517d4888$var$IDENTIFIER_PREFIX_RE.lastIndex = index;
    const match = $45586c55517d4888$var$IDENTIFIER_PREFIX_RE.exec(s);
    return match[1] ?? "";
}
class $45586c55517d4888$export$7acfa6ed01010e37 {
    message;
    position;
    locale;
    ignoreTag;
    requiresOtherClause;
    shouldParseSkeletons;
    constructor(message, options = {}){
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    parse() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    }
    parseMessage(nestingLevel, parentArgType, expectingCloseTag) {
        let elements = [];
        while(!this.isEOF()){
            const char = this.char();
            if (char === 123) {
                const result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 && nestingLevel > 0) break;
            else if (char === 35 && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                const position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).pound,
                    location: $45586c55517d4888$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 && !this.ignoreTag && this.peek() === 47) {
                if (expectingCloseTag) break;
                else return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $45586c55517d4888$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 && !this.ignoreTag && $45586c55517d4888$var$_isAlpha(this.peek() || 0)) {
                const result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                const result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    }
    /**
	* A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	* [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	* are accepted:
	*
	* ```
	* tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	* tagName ::= [a-z] (PENChar)*
	* PENChar ::=
	*     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	*     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	*     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	* ```
	*
	* [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	* NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	* since other tag-based engines like React allow it
	*/ parseTag(nestingLevel, parentArgType) {
        const startPosition = this.clonePosition();
        this.bump();
        const tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).literal,
                value: `<${tagName}/>`,
                location: $45586c55517d4888$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            const childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            const children = childrenResult.val;
            // Expecting a close tag
            const endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$45586c55517d4888$var$_isAlpha(this.char())) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).INVALID_TAG, $45586c55517d4888$var$createLocation(endTagStartPosition, this.clonePosition()));
                const closingTagNameStartPosition = this.clonePosition();
                const closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $45586c55517d4888$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).INVALID_TAG, $45586c55517d4888$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $45586c55517d4888$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).UNCLOSED_TAG, $45586c55517d4888$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).INVALID_TAG, $45586c55517d4888$var$createLocation(startPosition, this.clonePosition()));
    }
    /**
	* This method assumes that the caller has peeked ahead for the first tag character.
	*/ parseTagName() {
        const startOffset = this.offset();
        this.bump();
        while(!this.isEOF() && $45586c55517d4888$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    }
    parseLiteral(nestingLevel, parentArgType) {
        const start = this.clonePosition();
        let value = "";
        while(true){
            const parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            const parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            const parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        const location = $45586c55517d4888$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    }
    tryParseLeftAngleBracket() {
        if (!this.isEOF() && this.char() === 60 && (this.ignoreTag || !$45586c55517d4888$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump();
            return "<";
        }
        return null;
    }
    /**
	* Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	* a character that requires quoting (that is, "only where needed"), and works the same in
	* nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	*/ tryParseQuote(parentArgType) {
        if (this.isEOF() || this.char() !== 39) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump();
        const codePoints = [
            this.char()
        ];
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            const ch = this.char();
            if (ch === 39) {
                if (this.peek() === 39) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return String.fromCodePoint(...codePoints);
    }
    tryParseUnquoted(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        const ch = this.char();
        if (ch === 60 || ch === 123 || ch === 35 && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 && nestingLevel > 0) return null;
        else {
            this.bump();
            return String.fromCodePoint(ch);
        }
    }
    parseArgument(nestingLevel, expectingCloseTag) {
        const openingBracePosition = this.clonePosition();
        this.bump();
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125) {
            this.bump();
            return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EMPTY_ARGUMENT, $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        let value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).MALFORMED_ARGUMENT, $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            case 125:
                this.bump();
                return {
                    val: {
                        type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).argument,
                        value: value,
                        location: $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            case 44:
                this.bump();
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).MALFORMED_ARGUMENT, $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    }
    /**
	* Advance the parser until the end of the identifier, if it is currently on
	* an identifier character. Return an empty string otherwise.
	*/ parseIdentifierIfPossible() {
        const startingPosition = this.clonePosition();
        const startOffset = this.offset();
        const value = $45586c55517d4888$var$matchIdentifierAtIndex(this.message, startOffset);
        const endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        const endPosition = this.clonePosition();
        const location = $45586c55517d4888$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    }
    parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        // Parse this range:
        // {name, type, style}
        //        ^---^
        let typeStartPosition = this.clonePosition();
        let argType = this.parseIdentifierIfPossible().value;
        let typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $45586c55517d4888$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                {
                    // Parse this range:
                    // {name, number, style}
                    //              ^-------^
                    this.bumpSpace();
                    let styleAndLocation = null;
                    if (this.bumpIf(",")) {
                        this.bumpSpace();
                        const styleStartPosition = this.clonePosition();
                        const result = this.parseSimpleArgStyleIfPossible();
                        if (result.err) return result;
                        const style = $45586c55517d4888$var$trimEnd(result.val);
                        if (style.length === 0) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $45586c55517d4888$var$createLocation(this.clonePosition(), this.clonePosition()));
                        const styleLocation = $45586c55517d4888$var$createLocation(styleStartPosition, this.clonePosition());
                        styleAndLocation = {
                            style: style,
                            styleLocation: styleLocation
                        };
                    }
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition());
                    // Extract style or skeleton
                    if (styleAndLocation && styleAndLocation.style.startsWith("::")) {
                        // Skeleton starts with `::`.
                        let skeleton = $45586c55517d4888$var$trimStart(styleAndLocation.style.slice(2));
                        if (argType === "number") {
                            const result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                            if (result.err) return result;
                            return {
                                val: {
                                    type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).number,
                                    value: value,
                                    location: location,
                                    style: result.val
                                },
                                err: null
                            };
                        } else {
                            if (skeleton.length === 0) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location);
                            let dateTimePattern = skeleton;
                            // Get "best match" pattern only if locale is passed, if not, let it
                            // pass as-is where `parseDateTimeSkeleton()` will throw an error
                            // for unsupported patterns.
                            if (this.locale) dateTimePattern = (0, $e6e26a908bd84906$export$29c5368be8904d27)(skeleton, this.locale);
                            const style = {
                                type: (0, $08f109f7ae08cdee$export$906452485466fa53).dateTime,
                                pattern: dateTimePattern,
                                location: styleAndLocation.styleLocation,
                                parsedOptions: this.shouldParseSkeletons ? (0, $0d541ce8956791f4$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                            };
                            const type = argType === "date" ? (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).date : (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).time;
                            return {
                                val: {
                                    type: type,
                                    value: value,
                                    location: location,
                                    style: style
                                },
                                err: null
                            };
                        }
                    }
                    // Regular style or no style.
                    return {
                        val: {
                            type: argType === "number" ? (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).number : argType === "date" ? (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).date : (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).time,
                            value: value,
                            location: location,
                            style: styleAndLocation?.style ?? null
                        },
                        err: null
                    };
                }
            case "plural":
            case "selectordinal":
            case "select":
                {
                    // Parse this range:
                    // {name, plural, options}
                    //              ^---------^
                    const typeEndPosition = this.clonePosition();
                    this.bumpSpace();
                    if (!this.bumpIf(",")) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $45586c55517d4888$var$createLocation(typeEndPosition, {
                        ...typeEndPosition
                    }));
                    this.bumpSpace();
                    // Parse offset:
                    // {name, plural, offset:1, options}
                    //                ^-----^
                    //
                    // or the first option:
                    //
                    // {name, plural, one {...} other {...}}
                    //                ^--^
                    let identifierAndLocation = this.parseIdentifierIfPossible();
                    let pluralOffset = 0;
                    if (argType !== "select" && identifierAndLocation.value === "offset") {
                        if (!this.bumpIf(":")) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $45586c55517d4888$var$createLocation(this.clonePosition(), this.clonePosition()));
                        this.bumpSpace();
                        const result = this.tryParseDecimalInteger((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $bfc08167ad7a6652$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                        if (result.err) return result;
                        // Parse another identifier for option parsing
                        this.bumpSpace();
                        identifierAndLocation = this.parseIdentifierIfPossible();
                        pluralOffset = result.val;
                    }
                    const optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                    if (optionsResult.err) return optionsResult;
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition());
                    if (argType === "select") return {
                        val: {
                            type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).select,
                            value: value,
                            options: $45586c55517d4888$var$fromEntries(optionsResult.val),
                            location: location
                        },
                        err: null
                    };
                    else return {
                        val: {
                            type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).plural,
                            value: value,
                            options: $45586c55517d4888$var$fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === "plural" ? "cardinal" : "ordinal",
                            location: location
                        },
                        err: null
                    };
                }
            default:
                return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $45586c55517d4888$var$createLocation(typeStartPosition, typeEndPosition));
        }
    }
    tryParseArgumentClose(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump();
        return {
            val: true,
            err: null
        };
    }
    /**
	* See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	*/ parseSimpleArgStyleIfPossible() {
        let nestedBraces = 0;
        const startPosition = this.clonePosition();
        while(!this.isEOF()){
            const ch = this.char();
            switch(ch){
                case 39:
                    {
                        // Treat apostrophe as quoting but include it in the style part.
                        // Find the end of the quoted literal text.
                        this.bump();
                        let apostrophePosition = this.clonePosition();
                        if (!this.bumpUntil("'")) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $45586c55517d4888$var$createLocation(apostrophePosition, this.clonePosition()));
                        this.bump();
                        break;
                    }
                case 123:
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125:
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    }
    parseNumberSkeletonFromString(skeleton, location) {
        let tokens = [];
        try {
            tokens = (0, $0b4d7b961c3a6f72$export$71cee2f16fba2480)(skeleton);
        } catch  {
            return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $08f109f7ae08cdee$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $0b4d7b961c3a6f72$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    }
    /**
	* @param nesting_level The current nesting level of messages.
	*     This can be positive when parsing message fragment in select or plural argument options.
	* @param parent_arg_type The parent argument's type.
	* @param parsed_first_identifier If provided, this is the first identifier-like selector of
	*     the argument. It is a by-product of a previous parsing attempt.
	* @param expecting_close_tag If true, this message is directly or indirectly nested inside
	*     between a pair of opening and closing tags. The nested message will not parse beyond
	*     the closing tag boundary.
	*/ tryParsePluralOrSelectOptions(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        let hasOtherClause = false;
        const options = [];
        const parsedSelectors = new Set();
        let { value: selector, location: selectorLocation } = parsedFirstIdentifier;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                const startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    const result = this.tryParseDecimalInteger((0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $bfc08167ad7a6652$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $45586c55517d4888$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $bfc08167ad7a6652$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $bfc08167ad7a6652$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            const openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $45586c55517d4888$var$createLocation(this.clonePosition(), this.clonePosition()));
            const fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $45586c55517d4888$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            ({ value: selector, location: selectorLocation } = this.parseIdentifierIfPossible());
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $bfc08167ad7a6652$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $45586c55517d4888$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $bfc08167ad7a6652$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $45586c55517d4888$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    }
    tryParseDecimalInteger(expectNumberError, invalidNumberError) {
        let sign = 1;
        const startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        let hasDigits = false;
        let decimal = 0;
        while(!this.isEOF()){
            const ch = this.char();
            if (ch >= 48 && ch <= 57) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        const location = $45586c55517d4888$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!Number.isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    }
    offset() {
        return this.position.offset;
    }
    isEOF() {
        return this.offset() === this.message.length;
    }
    clonePosition() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    }
    /**
	* Return the code point at the current position of the parser.
	* Throws if the index is out of bound.
	*/ char() {
        const offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        const code = this.message.codePointAt(offset);
        if (code === undefined) throw Error(`Offset ${offset} is at invalid UTF-16 code unit boundary`);
        return code;
    }
    error(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    }
    /** Bump the parser to the next UTF-16 code unit. */ bump() {
        if (this.isEOF()) return;
        const code = this.char();
        if (code === 10) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 65536 ? 1 : 2;
        }
    }
    /**
	* If the substring starting at the current position of the parser has
	* the given prefix, then bump the parser to the character immediately
	* following the prefix and return true. Otherwise, don't bump the parser
	* and return false.
	*/ bumpIf(prefix) {
        if (this.message.startsWith(prefix, this.offset())) {
            for(let i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    }
    /**
	* Bump the parser until the pattern character is found and return `true`.
	* Otherwise bump to the end of the file and return `false`.
	*/ bumpUntil(pattern) {
        const currentOffset = this.offset();
        const index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    }
    /**
	* Bump the parser to the target offset.
	* If target offset is beyond the end of the input, bump the parser to the end of the input.
	*/ bumpTo(targetOffset) {
        if (this.offset() > targetOffset) throw Error(`targetOffset ${targetOffset} must be greater than or equal to the current offset ${this.offset()}`);
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            const offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error(`targetOffset ${targetOffset} is at invalid UTF-16 code unit boundary`);
            this.bump();
            if (this.isEOF()) break;
        }
    }
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ bumpSpace() {
        while(!this.isEOF() && $45586c55517d4888$var$_isWhiteSpace(this.char()))this.bump();
    }
    /**
	* Peek at the *next* Unicode codepoint in the input without advancing the parser.
	* If the input has been exhausted, then this returns null.
	*/ peek() {
        if (this.isEOF()) return null;
        const code = this.char();
        const offset = this.offset();
        const nextCode = this.message.charCodeAt(offset + (code >= 65536 ? 2 : 1));
        return nextCode ?? null;
    }
}
/**
* This check if codepoint is alphabet (lower & uppercase)
* @param codepoint
* @returns
*/ function $45586c55517d4888$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $45586c55517d4888$var$_isAlphaOrSlash(codepoint) {
    return $45586c55517d4888$var$_isAlpha(codepoint) || codepoint === 47;
}
/** See `parseTag` function docs. */ function $45586c55517d4888$var$_isPotentialElementNameChar(c) {
    return c === 45 || c === 46 || c >= 48 && c <= 57 || c === 95 || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 183 || c >= 192 && c <= 214 || c >= 216 && c <= 246 || c >= 248 && c <= 893 || c >= 895 && c <= 8191 || c >= 8204 && c <= 8205 || c >= 8255 && c <= 8256 || c >= 8304 && c <= 8591 || c >= 11264 && c <= 12271 || c >= 12289 && c <= 55295 || c >= 63744 && c <= 64975 || c >= 65008 && c <= 65533 || c >= 65536 && c <= 983039;
}
/**
* Code point equivalent of regex `\p{White_Space}`.
* From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
*/ function $45586c55517d4888$var$_isWhiteSpace(c) {
    return c >= 9 && c <= 13 || c === 32 || c === 133 || c >= 8206 && c <= 8207 || c === 8232 || c === 8233;
}




function $0233bd81662a327b$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return obj.map($0233bd81662a327b$var$cloneDeep);
    if (obj !== null && typeof obj === "object") // @ts-expect-error meh
    return Object.keys(obj).reduce((cloned, k)=>{
        // @ts-expect-error meh
        cloned[k] = $0233bd81662a327b$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
/**
* Replace pound elements with number elements referencing the given variable.
* This is needed when nesting plurals - the # in the outer plural should become
* an explicit variable reference when nested inside another plural.
* GH #4202
*/ function $0233bd81662a327b$var$replacePoundWithArgument(ast, variableName) {
    return ast.map((el)=>{
        if ((0, $08f109f7ae08cdee$export$c0ece297bdd0c082)(el)) // Replace # with {variableName, number}
        return {
            type: (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).number,
            value: variableName,
            style: null,
            location: el.location
        };
        if ((0, $08f109f7ae08cdee$export$6c796d116f0a4fbc)(el) || (0, $08f109f7ae08cdee$export$dcfe1c11d168b5a1)(el)) {
            // Recursively process options
            const newOptions = {};
            for (const key of Object.keys(el.options))newOptions[key] = {
                value: $0233bd81662a327b$var$replacePoundWithArgument(el.options[key].value, variableName)
            };
            return {
                ...el,
                options: newOptions
            };
        }
        if ((0, $08f109f7ae08cdee$export$5c83de34745812b)(el)) return {
            ...el,
            children: $0233bd81662a327b$var$replacePoundWithArgument(el.children, variableName)
        };
        return el;
    });
}
function $0233bd81662a327b$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    const cloned = $0233bd81662a327b$var$cloneDeep(el);
    const { options: options } = cloned;
    // GH #4202: Check if there are other plural/select elements after this one
    const afterElements = ast.slice(positionToInject + 1);
    const hasSubsequentPluralOrSelect = afterElements.some($0233bd81662a327b$var$isPluralOrSelectElement);
    cloned.options = Object.keys(options).reduce((all, k)=>{
        let optionValue = options[k].value;
        // GH #4202: If there are subsequent plurals/selects and this is a plural,
        // replace # with explicit variable reference to avoid ambiguity
        if (hasSubsequentPluralOrSelect && (0, $08f109f7ae08cdee$export$6c796d116f0a4fbc)(el)) optionValue = $0233bd81662a327b$var$replacePoundWithArgument(optionValue, el.value);
        const newValue = $0233bd81662a327b$export$be5687ba8bbdf416([
            ...ast.slice(0, positionToInject),
            ...optionValue,
            ...afterElements
        ]);
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $0233bd81662a327b$var$isPluralOrSelectElement(el) {
    return (0, $08f109f7ae08cdee$export$6c796d116f0a4fbc)(el) || (0, $08f109f7ae08cdee$export$dcfe1c11d168b5a1)(el);
}
function $0233bd81662a327b$var$findPluralOrSelectElement(ast) {
    return !!ast.find((el)=>{
        if ($0233bd81662a327b$var$isPluralOrSelectElement(el)) return true;
        if ((0, $08f109f7ae08cdee$export$5c83de34745812b)(el)) return $0233bd81662a327b$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $0233bd81662a327b$export$be5687ba8bbdf416(ast) {
    for(let i = 0; i < ast.length; i++){
        const el = ast[i];
        if ($0233bd81662a327b$var$isPluralOrSelectElement(el)) return [
            $0233bd81662a327b$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $08f109f7ae08cdee$export$5c83de34745812b)(el) && $0233bd81662a327b$var$findPluralOrSelectElement([
            el
        ])) throw new Error("Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option");
    }
    return ast;
}
/**
* Collect all variables in an AST to Record<string, TYPE>
* @param ast AST to collect variables from
* @param vars Record of variable name to variable type
*/ function $0233bd81662a327b$var$collectVariables(ast, vars = new Map()) {
    ast.forEach((el)=>{
        if ((0, $08f109f7ae08cdee$export$4f55724281bdfaf9)(el) || (0, $08f109f7ae08cdee$export$32d811605da75f40)(el) || (0, $08f109f7ae08cdee$export$34ec46f596b1702f)(el) || (0, $08f109f7ae08cdee$export$e11187b219e191e1)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error(`Variable ${el.value} has conflicting types`);
            vars.set(el.value, el.type);
        }
        if ((0, $08f109f7ae08cdee$export$6c796d116f0a4fbc)(el) || (0, $08f109f7ae08cdee$export$dcfe1c11d168b5a1)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach((k)=>{
                $0233bd81662a327b$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $08f109f7ae08cdee$export$5c83de34745812b)(el)) {
            vars.set(el.value, el.type);
            $0233bd81662a327b$var$collectVariables(el.children, vars);
        }
    });
}
function $0233bd81662a327b$export$1edd9c892fdd9d27(a, b) {
    const aVars = new Map();
    const bVars = new Map();
    $0233bd81662a327b$var$collectVariables(a, aVars);
    $0233bd81662a327b$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error(`Different number of variables: [${Array.from(aVars.keys()).join(", ")}] vs [${Array.from(bVars.keys()).join(", ")}]`)
    };
    return Array.from(aVars.entries()).reduce((result, [key, type])=>{
        if (!result.success) return result;
        const bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error(`Missing variable ${key} in message`)
        };
        if (bType !== type) return {
            success: false,
            error: new Error(`Variable ${key} has conflicting types: ${(0, $08f109f7ae08cdee$export$b87f371cbc396fcf)[type]} vs ${(0, $08f109f7ae08cdee$export$b87f371cbc396fcf)[bType]}`)
        };
        return result;
    }, {
        success: true
    });
}


function $2dc2f66d316cd8db$var$pruneLocation(els) {
    els.forEach((el)=>{
        delete el.location;
        if ((0, $08f109f7ae08cdee$export$dcfe1c11d168b5a1)(el) || (0, $08f109f7ae08cdee$export$6c796d116f0a4fbc)(el)) for(const k in el.options){
            delete el.options[k].location;
            $2dc2f66d316cd8db$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $08f109f7ae08cdee$export$e11187b219e191e1)(el) && (0, $08f109f7ae08cdee$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $08f109f7ae08cdee$export$32d811605da75f40)(el) || (0, $08f109f7ae08cdee$export$34ec46f596b1702f)(el)) && (0, $08f109f7ae08cdee$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $08f109f7ae08cdee$export$5c83de34745812b)(el)) $2dc2f66d316cd8db$var$pruneLocation(el.children);
    });
}
function $2dc2f66d316cd8db$export$98e6a39c04603d36(message, opts = {}) {
    opts = {
        shouldParseSkeletons: true,
        requiresOtherClause: true,
        ...opts
    };
    const result = new (0, $45586c55517d4888$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        const error = SyntaxError((0, $bfc08167ad7a6652$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!opts?.captureLocation) $2dc2f66d316cd8db$var$pruneLocation(result.val);
    return result.val;
}
const $2dc2f66d316cd8db$export$d3c1bfa0f7d806e9 = (0, $45586c55517d4888$export$7acfa6ed01010e37);




let $1e3001a5433b9439$export$557d6acb76e8a244 = /* @__PURE__ */ function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
    return IntlErrorCode;
}({});
class $1e3001a5433b9439$export$c016d36112f6ddf8 extends Error {
    code;
    constructor(code, message, exception){
        const err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        super(`[@formatjs/intl Error ${code}] ${message}
${err ? `\n${err.message}\n${err.stack}` : ""}`);
        this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(this, $1e3001a5433b9439$export$c016d36112f6ddf8);
    }
}
class $1e3001a5433b9439$export$549f97e137a05c90 extends $1e3001a5433b9439$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super($1e3001a5433b9439$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception);
    }
}
class $1e3001a5433b9439$export$3ca04dd7fb305893 extends $1e3001a5433b9439$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super($1e3001a5433b9439$export$557d6acb76e8a244.INVALID_CONFIG, message, exception);
    }
}
class $1e3001a5433b9439$export$c1eaf877d81384b6 extends $1e3001a5433b9439$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super($1e3001a5433b9439$export$557d6acb76e8a244.MISSING_DATA, message, exception);
    }
}
class $1e3001a5433b9439$export$e3b7eee1dbc44895 extends $1e3001a5433b9439$export$c016d36112f6ddf8 {
    descriptor;
    locale;
    constructor(message, locale, exception){
        super($1e3001a5433b9439$export$557d6acb76e8a244.FORMAT_ERROR, `${message}
Locale: ${locale}
`, exception);
        this.locale = locale;
    }
}
class $1e3001a5433b9439$export$74a601a3d3f31621 extends $1e3001a5433b9439$export$e3b7eee1dbc44895 {
    descriptor;
    locale;
    constructor(message, locale, descriptor, exception){
        super(`${message}
MessageID: ${descriptor?.id}
Default Message: ${descriptor?.defaultMessage}
Description: ${descriptor?.description}
`, locale, exception);
        this.descriptor = descriptor;
        this.locale = locale;
    }
}
class $1e3001a5433b9439$export$2ddcb436d0aa3688 extends $1e3001a5433b9439$export$c016d36112f6ddf8 {
    descriptor;
    constructor(descriptor, locale){
        super($1e3001a5433b9439$export$557d6acb76e8a244.MISSING_TRANSLATION, `Missing message: "${descriptor.id}" for locale "${locale}", using ${descriptor.defaultMessage ? `default message (${typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map((e)=>e.value ?? JSON.stringify(e)).join()})` : "id"} as fallback.`);
        this.descriptor = descriptor;
    }
}



function $7bac09121bc9431c$export$fc10aeed3a532e2a(fn, options) {
    const cache = options && options.cache ? options.cache : $7bac09121bc9431c$var$cacheDefault;
    const serializer = options && options.serializer ? options.serializer : $7bac09121bc9431c$var$serializerDefault;
    const strategy = options && options.strategy ? options.strategy : $7bac09121bc9431c$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $7bac09121bc9431c$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean";
}
function $7bac09121bc9431c$var$monadic(fn, cache, serializer, arg) {
    const cacheKey = $7bac09121bc9431c$var$isPrimitive(arg) ? arg : serializer(arg);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7bac09121bc9431c$var$variadic(fn, cache, serializer) {
    const args = Array.prototype.slice.call(arguments, 3);
    const cacheKey = serializer(args);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7bac09121bc9431c$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $7bac09121bc9431c$var$strategyDefault(fn, options) {
    const strategy = fn.length === 1 ? $7bac09121bc9431c$var$monadic : $7bac09121bc9431c$var$variadic;
    return $7bac09121bc9431c$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $7bac09121bc9431c$var$strategyVariadic(fn, options) {
    return $7bac09121bc9431c$var$assemble(fn, this, $7bac09121bc9431c$var$variadic, options.cache.create(), options.serializer);
}
function $7bac09121bc9431c$var$strategyMonadic(fn, options) {
    return $7bac09121bc9431c$var$assemble(fn, this, $7bac09121bc9431c$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
const $7bac09121bc9431c$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
class $7bac09121bc9431c$var$ObjectWithoutPrototypeCache {
    cache;
    constructor(){
        this.cache = Object.create(null);
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
}
const $7bac09121bc9431c$var$cacheDefault = {
    create: function create() {
        return new $7bac09121bc9431c$var$ObjectWithoutPrototypeCache();
    }
};
const $7bac09121bc9431c$export$c5491a8691a23b9e = {
    variadic: $7bac09121bc9431c$var$strategyVariadic,
    monadic: $7bac09121bc9431c$var$strategyMonadic
};


var $cce7b597e4178fb0$exports = {};

$parcel$defineInteropFlag($cce7b597e4178fb0$exports);
$parcel$export($cce7b597e4178fb0$exports, "ErrorCode", () => $5dcc586802a30443$export$d4e71bc0b80dc0fb);
$parcel$export($cce7b597e4178fb0$exports, "FormatError", () => $5dcc586802a30443$export$7369836851cc1329);

$parcel$export($cce7b597e4178fb0$exports, "IntlMessageFormat", () => $c5b7ad20a151f4fd$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 



let $5dcc586802a30443$export$d4e71bc0b80dc0fb = /* @__PURE__ */ function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
    return ErrorCode;
}({});
class $5dcc586802a30443$export$7369836851cc1329 extends Error {
    code;
    /**
	* Original message we're trying to format
	* `undefined` if we're only dealing w/ AST
	*
	* @type {(string | undefined)}
	* @memberof FormatError
	*/ originalMessage;
    constructor(msg, code, originalMessage){
        super(msg);
        this.code = code;
        this.originalMessage = originalMessage;
    }
    toString() {
        return `[formatjs Error: ${this.code}] ${this.message}`;
    }
}
class $5dcc586802a30443$export$565c3afc07dfa382 extends $5dcc586802a30443$export$7369836851cc1329 {
    constructor(variableId, value, options, originalMessage){
        super(`Invalid values for "${variableId}": "${value}". Options are "${Object.keys(options).join("\", \"")}"`, $5dcc586802a30443$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage);
    }
}
class $5dcc586802a30443$export$cbc0db47c750f7c9 extends $5dcc586802a30443$export$7369836851cc1329 {
    constructor(value, type, originalMessage){
        super(`Value for "${value}" must be of type ${type}`, $5dcc586802a30443$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage);
    }
}
class $5dcc586802a30443$export$8bfc137e4d23fdf0 extends $5dcc586802a30443$export$7369836851cc1329 {
    constructor(variableId, originalMessage){
        super(`The intl string context variable "${variableId}" was not provided to the string "${originalMessage}"`, $5dcc586802a30443$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage);
    }
}


let $5aa6dc894e760a0a$export$49694c2877b44c57 = /* @__PURE__ */ function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
    return PART_TYPE;
}({});
function $5aa6dc894e760a0a$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce((all, part)=>{
        const lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $5aa6dc894e760a0a$export$49694c2877b44c57.literal || part.type !== $5aa6dc894e760a0a$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $5aa6dc894e760a0a$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $5aa6dc894e760a0a$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $08f109f7ae08cdee$export$cfa10c5697238752)(els[0])) return [
        {
            type: $5aa6dc894e760a0a$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    const result = [];
    for (const el of els){
        // Exit early for string parts.
        if ((0, $08f109f7ae08cdee$export$cfa10c5697238752)(el)) {
            result.push({
                type: $5aa6dc894e760a0a$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $08f109f7ae08cdee$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $5aa6dc894e760a0a$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        const { value: varName } = el;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $5dcc586802a30443$export$8bfc137e4d23fdf0)(varName, originalMessage);
        let value = values[varName];
        if ((0, $08f109f7ae08cdee$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === "string" || typeof value === "number" || typeof value === "bigint") value = typeof value === "string" || typeof value === "number" || typeof value === "bigint" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $5aa6dc894e760a0a$export$49694c2877b44c57.literal : $5aa6dc894e760a0a$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $08f109f7ae08cdee$export$32d811605da75f40)(el)) {
            const style = typeof el.style === "string" ? formats.date[el.style] : (0, $08f109f7ae08cdee$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $5aa6dc894e760a0a$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $08f109f7ae08cdee$export$34ec46f596b1702f)(el)) {
            const style = typeof el.style === "string" ? formats.time[el.style] : (0, $08f109f7ae08cdee$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $5aa6dc894e760a0a$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $08f109f7ae08cdee$export$e11187b219e191e1)(el)) {
            const style = typeof el.style === "string" ? formats.number[el.style] : (0, $08f109f7ae08cdee$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) {
                const scale = style.scale || 1;
                // Handle bigint scale multiplication
                // BigInt can only be multiplied by BigInt
                if (typeof value === "bigint") {
                    // Check if scale is a safe integer that can be converted to BigInt
                    if (!Number.isInteger(scale)) throw new TypeError(`Cannot apply fractional scale ${scale} to bigint value. Scale must be an integer when formatting bigint.`);
                    value = value * BigInt(scale);
                } else value = value * scale;
            }
            result.push({
                type: $5aa6dc894e760a0a$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $08f109f7ae08cdee$export$5c83de34745812b)(el)) {
            const { children: children, value: value } = el;
            const formatFn = values[value];
            if (!$5aa6dc894e760a0a$export$df0c12a2d414a163(formatFn)) throw new (0, $5dcc586802a30443$export$cbc0db47c750f7c9)(value, "function", originalMessage);
            const parts = $5aa6dc894e760a0a$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            let chunks = formatFn(parts.map((p)=>p.value));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push(...chunks.map((c)=>{
                return {
                    type: typeof c === "string" ? $5aa6dc894e760a0a$export$49694c2877b44c57.literal : $5aa6dc894e760a0a$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $08f109f7ae08cdee$export$dcfe1c11d168b5a1)(el)) {
            // GH #4490: Use hasOwnProperty to avoid prototype chain issues with keys like "constructor"
            const key = value;
            const opt = (Object.prototype.hasOwnProperty.call(el.options, key) ? el.options[key] : undefined) || el.options.other;
            if (!opt) throw new (0, $5dcc586802a30443$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push(...$5aa6dc894e760a0a$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $08f109f7ae08cdee$export$6c796d116f0a4fbc)(el)) {
            // GH #4490: Use hasOwnProperty to avoid prototype chain issues
            const exactKey = `=${value}`;
            let opt = Object.prototype.hasOwnProperty.call(el.options, exactKey) ? el.options[exactKey] : undefined;
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $5dcc586802a30443$export$7369836851cc1329)(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, (0, $5dcc586802a30443$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                // Convert bigint to number for PluralRules (which only accepts number)
                const numericValue = typeof value === "bigint" ? Number(value) : value;
                const rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(numericValue - (el.offset || 0));
                opt = (Object.prototype.hasOwnProperty.call(el.options, rule) ? el.options[rule] : undefined) || el.options.other;
            }
            if (!opt) throw new (0, $5dcc586802a30443$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            // Convert bigint to number for currentPluralValue
            const numericValue = typeof value === "bigint" ? Number(value) : value;
            result.push(...$5aa6dc894e760a0a$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, numericValue - (el.offset || 0)));
            continue;
        }
    }
    return $5aa6dc894e760a0a$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $c5b7ad20a151f4fd$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return {
        ...c1,
        ...c2,
        ...Object.keys(c1).reduce((all, k)=>{
            all[k] = {
                ...c1[k],
                ...c2[k]
            };
            return all;
        }, {})
    };
}
function $c5b7ad20a151f4fd$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce((all, k)=>{
        all[k] = $c5b7ad20a151f4fd$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, {
        ...defaultConfig
    });
}
function $c5b7ad20a151f4fd$var$createFastMemoizeCache(store) {
    return {
        create () {
            return {
                get (key) {
                    return store[key];
                },
                set (key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $c5b7ad20a151f4fd$var$createDefaultFormatters(cache = {
    number: {},
    dateTime: {},
    pluralRules: {}
}) {
    return {
        getNumberFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.NumberFormat(...args), {
            cache: $c5b7ad20a151f4fd$var$createFastMemoizeCache(cache.number),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.DateTimeFormat(...args), {
            cache: $c5b7ad20a151f4fd$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.PluralRules(...args), {
            cache: $c5b7ad20a151f4fd$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        })
    };
}
class $c5b7ad20a151f4fd$export$d342343268debc40 {
    ast;
    locales;
    resolvedLocale;
    formatters;
    formats;
    message;
    formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    constructor(message, locales = $c5b7ad20a151f4fd$export$d342343268debc40.defaultLocale, overrideFormats, opts){
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = $c5b7ad20a151f4fd$export$d342343268debc40.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!$c5b7ad20a151f4fd$export$d342343268debc40.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            const { ...parseOpts } = opts || {};
            // Parse string messages into an AST.
            this.ast = $c5b7ad20a151f4fd$export$d342343268debc40.__parse(message, {
                ...parseOpts,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $c5b7ad20a151f4fd$var$mergeConfigs($c5b7ad20a151f4fd$export$d342343268debc40.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $c5b7ad20a151f4fd$var$createDefaultFormatters(this.formatterCache);
    }
    format = (values)=>{
        const parts = this.formatToParts(values);
        // Hot path for straight simple msg translations
        if (parts.length === 1) return parts[0].value;
        const result = parts.reduce((all, part)=>{
            if (!all.length || part.type !== (0, $5aa6dc894e760a0a$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
            else all[all.length - 1] += part.value;
            return all;
        }, []);
        if (result.length <= 1) return result[0] || "";
        return result;
    };
    formatToParts = (values)=>(0, $5aa6dc894e760a0a$export$275d4a3bb5f66fda)(this.ast, this.locales, this.formatters, this.formats, values, undefined, this.message);
    resolvedOptions = ()=>({
            locale: this.resolvedLocale?.toString() || Intl.NumberFormat.supportedLocalesOf(this.locales)[0]
        });
    getAst = ()=>this.ast;
    static memoizedDefaultLocale = null;
    static get defaultLocale() {
        if (!$c5b7ad20a151f4fd$export$d342343268debc40.memoizedDefaultLocale) $c5b7ad20a151f4fd$export$d342343268debc40.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
        return $c5b7ad20a151f4fd$export$d342343268debc40.memoizedDefaultLocale;
    }
    static resolveLocale = (locales)=>{
        if (typeof Intl.Locale === "undefined") return;
        const supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    static __parse = (0, $2dc2f66d316cd8db$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    static formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
}




var $cce7b597e4178fb0$export$2e2bcd8739ae039 = (0, $c5b7ad20a151f4fd$export$d342343268debc40);




function $f757d3c84c157611$export$f5708dca728d7177(condition, message, Err = Error) {
    if (!condition) throw new Err(message);
}
function $f757d3c84c157611$export$d697c39a2985a4c(props, allowlist, defaults = {}) {
    return allowlist.reduce((filtered, name)=>{
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
const $f757d3c84c157611$var$defaultErrorHandler = (error)=>{};
const $f757d3c84c157611$var$defaultWarnHandler = (warning)=>{};
const $f757d3c84c157611$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $f757d3c84c157611$var$defaultErrorHandler,
    onWarn: $f757d3c84c157611$var$defaultWarnHandler
};
function $f757d3c84c157611$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $f757d3c84c157611$var$createFastMemoizeCache(store) {
    return {
        create () {
            return {
                get (key) {
                    return store[key];
                },
                set (key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $f757d3c84c157611$export$c3f4cd5551df13fd(cache = $f757d3c84c157611$export$51c4f4e973f2dc00()) {
    const RelativeTimeFormat = Intl.RelativeTimeFormat;
    const ListFormat = Intl.ListFormat;
    const DisplayNames = Intl.DisplayNames;
    const getDateTimeFormat = (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.DateTimeFormat(...args), {
        cache: $f757d3c84c157611$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
    });
    const getNumberFormat = (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.NumberFormat(...args), {
        cache: $f757d3c84c157611$var$createFastMemoizeCache(cache.number),
        strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
    });
    const getPluralRules = (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.PluralRules(...args), {
        cache: $f757d3c84c157611$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((message, locales, overrideFormats, opts)=>new (0, $c5b7ad20a151f4fd$export$d342343268debc40)(message, locales, overrideFormats, {
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                },
                ...opts
            }), {
            cache: $f757d3c84c157611$var$createFastMemoizeCache(cache.message),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new RelativeTimeFormat(...args), {
            cache: $f757d3c84c157611$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new ListFormat(...args), {
            cache: $f757d3c84c157611$var$createFastMemoizeCache(cache.list),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new DisplayNames(...args), {
            cache: $f757d3c84c157611$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        })
    };
}
function $f757d3c84c157611$export$4ee1db8ce44a209b(formats, type, name, onError) {
    const formatType = formats && formats[type];
    let format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $1e3001a5433b9439$export$549f97e137a05c90)(`No ${type} format named: ${name}`));
}


const $d3a7e2f1284c9ce0$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    "numberingSystem",
    "fractionalSecondDigits"
];
function $d3a7e2f1284c9ce0$export$a7f9565e3c81cd54({ locale: locale, formats: formats, onError: onError, timeZone: timeZone }, type, getDateTimeFormat, options = {}) {
    const { format: format } = options;
    const defaults = {
        ...timeZone && {
            timeZone: timeZone
        },
        ...format && (0, $f757d3c84c157611$export$4ee1db8ce44a209b)(formats, type, format, onError)
    };
    let filteredOptions = (0, $f757d3c84c157611$export$d697c39a2985a4c)(options, $d3a7e2f1284c9ce0$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = {
        ...filteredOptions,
        hour: "numeric",
        minute: "numeric"
    };
    return getDateTimeFormat(locale, filteredOptions);
}
function $d3a7e2f1284c9ce0$export$3ae94a2503e890a1(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $d3a7e2f1284c9ce0$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $d3a7e2f1284c9ce0$export$3203edd9e5edd663(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $d3a7e2f1284c9ce0$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $d3a7e2f1284c9ce0$export$a7fc3a91cb2ec376(config, getDateTimeFormat, from, to, options = {}) {
    const fromDate = typeof from === "string" ? new Date(from || 0) : from;
    const toDate = typeof to === "string" ? new Date(to || 0) : to;
    try {
        return $d3a7e2f1284c9ce0$export$a7f9565e3c81cd54(config, "dateTimeRange", getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting date time range.", config.locale, e));
    }
    return String(fromDate);
}
function $d3a7e2f1284c9ce0$export$dc1f059bce486b1(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $d3a7e2f1284c9ce0$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $d3a7e2f1284c9ce0$export$af6e5d7a5c73edeb(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $d3a7e2f1284c9ce0$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting time.", config.locale, e));
    }
    return [];
}






const $f6d357d00ca6b2a4$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $f6d357d00ca6b2a4$export$62fe1a4d9e891fa2({ locale: locale, onError: onError }, getDisplayNames, value, options) {
    const DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $5dcc586802a30443$export$7369836851cc1329)(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, (0, $5dcc586802a30443$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = (0, $f757d3c84c157611$export$d697c39a2985a4c)(options, $f6d357d00ca6b2a4$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting display name.", locale, e));
    }
}







const $74932f5f5fd5a955$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
const $74932f5f5fd5a955$var$now = Date.now();
function $74932f5f5fd5a955$var$generateToken(i) {
    return `${$74932f5f5fd5a955$var$now}_${i}_${$74932f5f5fd5a955$var$now}`;
}
function $74932f5f5fd5a955$export$e8b8be48b45905bb(opts, getListFormat, values, options = {}) {
    const results = $74932f5f5fd5a955$export$6f284aad1934db69(opts, getListFormat, values, options).reduce((all, el)=>{
        const val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $74932f5f5fd5a955$export$6f284aad1934db69({ locale: locale, onError: onError }, getListFormat, values, options = {}) {
    const ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $5dcc586802a30443$export$7369836851cc1329)(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, (0, $5dcc586802a30443$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = (0, $f757d3c84c157611$export$d697c39a2985a4c)(options, $74932f5f5fd5a955$var$LIST_FORMAT_OPTIONS);
    try {
        const richValues = {};
        const serializedValues = Array.from(values).map((v, i)=>{
            if (typeof v === "object" && v !== null) {
                const id = $74932f5f5fd5a955$var$generateToken(i);
                richValues[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map((part)=>part.type === "literal" ? part : {
                ...part,
                value: richValues[part.value] || part.value
            });
    } catch (e) {
        onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}







function $6447f3050ed9b6d6$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce((all, k)=>{
        all[k] = {
            timeZone: timeZone,
            ...opts[k]
        };
        return all;
    }, {});
}
function $6447f3050ed9b6d6$var$deepMergeOptions(opts1, opts2) {
    const keys = Object.keys({
        ...opts1,
        ...opts2
    });
    return keys.reduce((all, k)=>{
        all[k] = {
            ...opts1[k],
            ...opts2[k]
        };
        return all;
    }, {});
}
function $6447f3050ed9b6d6$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    const mfFormats = (0, $c5b7ad20a151f4fd$export$d342343268debc40).formats;
    return {
        ...mfFormats,
        ...f1,
        date: $6447f3050ed9b6d6$var$deepMergeOptions($6447f3050ed9b6d6$var$setTimeZoneInOptions(mfFormats.date, timeZone), $6447f3050ed9b6d6$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $6447f3050ed9b6d6$var$deepMergeOptions($6447f3050ed9b6d6$var$setTimeZoneInOptions(mfFormats.time, timeZone), $6447f3050ed9b6d6$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    };
}
const $6447f3050ed9b6d6$export$25868d1e8e76735f = ({ locale: locale, formats: formats, messages: messages, defaultLocale: defaultLocale, defaultFormats: defaultFormats, fallbackOnEmptyString: fallbackOnEmptyString, onError: onError, timeZone: timeZone, defaultRichTextElements: defaultRichTextElements }, state, messageDescriptor = {
    id: ""
}, values, opts)=>{
    const { id: msgId, defaultMessage: defaultMessage } = messageDescriptor;
    // `id` is a required field of a Message Descriptor.
    (0, $f757d3c84c157611$export$f5708dca728d7177)(!!msgId, `[@formatjs/intl] An \`id\` must be provided to format a message. You can either:
1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)
or [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR
2. Configure your \`eslint\` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)
to autofix this issue`);
    const id = String(msgId);
    const message = messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $08f109f7ae08cdee$export$b87f371cbc396fcf).literal) return message[0].value;
    values = {
        ...defaultRichTextElements,
        ...values
    };
    formats = $6447f3050ed9b6d6$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $6447f3050ed9b6d6$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $1e3001a5433b9439$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            const formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $1e3001a5433b9439$export$74a601a3d3f31621)(`Error formatting default message for: "${id}", rendering default message verbatim`, locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        const formatter = state.getMessageFormat(message, locale, formats, {
            formatters: state,
            ...opts
        });
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $1e3001a5433b9439$export$74a601a3d3f31621)(`Error formatting message: "${id}", using ${defaultMessage ? "default message" : "id"} as fallback.`, locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        const formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $1e3001a5433b9439$export$74a601a3d3f31621)(`Error formatting the default message for: "${id}", rendering message verbatim`, locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};






const $3f2d2086fd02d380$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    "trailingZeroDisplay",
    "roundingPriority",
    "roundingIncrement",
    "roundingMode"
];
function $3f2d2086fd02d380$export$a7f9565e3c81cd54({ locale: locale, formats: formats, onError: onError }, getNumberFormat, options = {}) {
    const { format: format } = options;
    const defaults = format && (0, $f757d3c84c157611$export$4ee1db8ce44a209b)(formats, "number", format, onError) || {};
    const filteredOptions = (0, $f757d3c84c157611$export$d697c39a2985a4c)(options, $3f2d2086fd02d380$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $3f2d2086fd02d380$export$f5dd818bff069720(config, getNumberFormat, value, options = {}) {
    try {
        return $3f2d2086fd02d380$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $3f2d2086fd02d380$export$6871080848f10b2f(config, getNumberFormat, value, options = {}) {
    try {
        return $3f2d2086fd02d380$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting number.", config.locale, e));
    }
    return [];
}






const $62d6f25f73d315c1$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $62d6f25f73d315c1$export$bbbd05c900f3568d({ locale: locale, onError: onError }, getPluralRules, value, options = {}) {
    if (!Intl.PluralRules) onError(new (0, $5dcc586802a30443$export$7369836851cc1329)(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, (0, $5dcc586802a30443$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = (0, $f757d3c84c157611$export$d697c39a2985a4c)(options, $62d6f25f73d315c1$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting plural.", locale, e));
    }
    return "other";
}






const $a948a8e3ff808692$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $a948a8e3ff808692$var$getFormatter({ locale: locale, formats: formats, onError: onError }, getRelativeTimeFormat, options = {}) {
    const { format: format } = options;
    const defaults = !!format && (0, $f757d3c84c157611$export$4ee1db8ce44a209b)(formats, "relative", format, onError) || {};
    const filteredOptions = (0, $f757d3c84c157611$export$d697c39a2985a4c)(options, $a948a8e3ff808692$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $a948a8e3ff808692$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options = {}) {
    if (!unit) unit = "second";
    const RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $5dcc586802a30443$export$7369836851cc1329)(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, (0, $5dcc586802a30443$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $a948a8e3ff808692$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $1e3001a5433b9439$export$e3b7eee1dbc44895)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}




function $4e2ce40f1d68c95b$var$messagesContainString(messages) {
    const firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $4e2ce40f1d68c95b$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $4e2ce40f1d68c95b$var$messagesContainString(config.messages || {})) config.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.github.io/docs/getting-started/message-distribution`);
}
function $4e2ce40f1d68c95b$export$7e4cbedfdd7b4c0d(config, cache) {
    const formatters = (0, $f757d3c84c157611$export$c3f4cd5551df13fd)(cache);
    const resolvedConfig = {
        ...(0, $f757d3c84c157611$export$b52f8d6fc0d47415),
        ...config
    };
    const { locale: locale, defaultLocale: defaultLocale, onError: onError } = resolvedConfig;
    if (!locale) {
        if (onError) onError(new (0, $1e3001a5433b9439$export$3ca04dd7fb305893)(`"locale" was not configured, using "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details`));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $1e3001a5433b9439$export$c1eaf877d81384b6)(`Missing locale data for locale: "${locale}" in Intl.NumberFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $1e3001a5433b9439$export$c1eaf877d81384b6)(`Missing locale data for locale: "${locale}" in Intl.DateTimeFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
    $4e2ce40f1d68c95b$var$verifyConfigMessages(resolvedConfig);
    return {
        ...resolvedConfig,
        formatters: formatters,
        formatNumber: (0, $3f2d2086fd02d380$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $3f2d2086fd02d380$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $a948a8e3ff808692$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $d3a7e2f1284c9ce0$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $d3a7e2f1284c9ce0$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $d3a7e2f1284c9ce0$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $d3a7e2f1284c9ce0$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $d3a7e2f1284c9ce0$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $62d6f25f73d315c1$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $6447f3050ed9b6d6$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $6447f3050ed9b6d6$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $74932f5f5fd5a955$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $74932f5f5fd5a955$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $f6d357d00ca6b2a4$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    };
}


var $9d65c6413670394c$exports = {};
$9d65c6413670394c$exports = JSON.parse('{"app.title":"\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0442\u043E\u0440 \u0440\u0435\u0433\u0443\u043B\u044F\u0442\u043E\u0440\u043E\u0432","disconnected.previouslyConnected":"\u0420\u0430\u043D\u0435\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u0435","disconnected.connectionBaudRate":"\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F","disconnected.connectNewDevice":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E","connecting.selectDevice":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 USB-\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F...","error.tryAgain":"\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430","error.back":"\u041D\u0430\u0437\u0430\u0434","connected.status":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E","connected.helpText":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435","connected.disconnect":"\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C","connected.exportToFile":"\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u0444\u0430\u0439\u043B","connected.saveToDevice":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E","connected.serialPlaceholder":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0443...","connected.send":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C","alerts.noDevice":"\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E","alerts.saveSuccess":"\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0430 \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435!","alerts.saveFailure":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044E \u2014 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u043A\u043E\u043D\u0435\u0447\u043D\u0430\u044F \u0442\u043E\u0447\u043A\u0430 \u0441 \u0437\u0430\u043F\u0438\u0441\u044C\u044E.","alerts.saveError":"\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F: {error}","alerts.saving":"\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435...","errors.webusbNotSupported":"WebUSB \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0432 \u044D\u0442\u043E\u043C \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 Chrome \u0438\u043B\u0438 Edge.","errors.noDeviceSelected":"USB-\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430.","errors.permissionDenied":"\u0414\u043E\u0441\u0442\u0443\u043F \u0437\u0430\u043F\u0440\u0435\u0449\u0451\u043D. \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 HTTPS \u0438\u043B\u0438 localhost.","errors.failedToOpen":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043A\u0440\u044B\u0442\u044C USB-\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E: {error}","help.default":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"}');


var $f4fa5a20f4f20f57$exports = {};
$f4fa5a20f4f20f57$exports = JSON.parse('{"field.deviceName.name":"\u0418\u043C\u044F \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430","field.deviceName.help":"\u0427\u0438\u0442\u0430\u0435\u043C\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430. \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0432 \u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0445 \u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F.","field.deviceName.placeholder":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430","field.baudRate.name":"\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C (\u0431\u043E\u0434)","field.baudRate.help":"\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u0432 \u0431\u0438\u0442\u0430\u0445 \u0432 \u0441\u0435\u043A\u0443\u043D\u0434\u0443. \u0414\u043E\u043B\u0436\u043D\u0430 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u043E\u0439 \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430.","field.baudRate.option.9600":"9600","field.baudRate.option.19200":"19200","field.baudRate.option.38400":"38400","field.baudRate.option.57600":"57600","field.baudRate.option.115200":"115200","field.timeout.name":"\u0422\u0430\u0439\u043C-\u0430\u0443\u0442 (\u043C\u0441)","field.timeout.help":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043E\u0442\u0432\u0435\u0442\u0430 \u043F\u0435\u0440\u0435\u0434 \u0442\u0435\u043C, \u043A\u0430\u043A \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0441\u044F \u043D\u0435\u0443\u0434\u0430\u0447\u043D\u043E\u0439.","field.autoReconnect.name":"\u0410\u0432\u0442\u043E-\u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435","field.autoReconnect.help":"\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u044B\u0442\u0430\u0442\u044C\u0441\u044F \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F \u043F\u0440\u0438 \u043D\u0435\u043E\u0436\u0438\u0434\u0430\u043D\u043D\u043E\u0439 \u043F\u043E\u0442\u0435\u0440\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F.","field.retryCount.name":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u043E\u0432","field.retryCount.help":"\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u0440\u0430\u0437 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043D\u0435\u0443\u0434\u0430\u0447\u043D\u0443\u044E \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044E \u043F\u0435\u0440\u0435\u0434 \u0442\u0435\u043C, \u043A\u0430\u043A \u0441\u0434\u0430\u0442\u044C\u0441\u044F.","field.logLevel.name":"\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0436\u0443\u0440\u043D\u0430\u043B\u0430","field.logLevel.help":"\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0434\u0435\u0442\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430. Debug \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442 \u0432\u0441\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F, Error \u2014 \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0448\u0438\u0431\u043A\u0438.","field.logLevel.option.debug":"\u041E\u0442\u043B\u0430\u0434\u043A\u0430","field.logLevel.option.info":"\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F","field.logLevel.option.warning":"\u041F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435","field.logLevel.option.error":"\u041E\u0448\u0438\u0431\u043A\u0430"}');


const $da488e969ff3960b$var$ru = {
    ...(0, (/*@__PURE__*/$parcel$interopDefault($9d65c6413670394c$exports))),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($f4fa5a20f4f20f57$exports)))
};
const $da488e969ff3960b$export$7776f9b2588efe5b = (0, $4e2ce40f1d68c95b$export$7e4cbedfdd7b4c0d)({
    locale: 'ru',
    defaultLocale: 'ru',
    messages: $da488e969ff3960b$var$ru,
    onError: ()=>{}
});
function $da488e969ff3960b$export$625550452a3fa3ec(id, values) {
    return $da488e969ff3960b$export$7776f9b2588efe5b.formatMessage({
        id: id
    }, values);
}


/// <reference types="w3c-web-usb" />


const $e3d6ee63ed1479b9$var$CONNECTION_BAUD_OPTIONS = [
    9600,
    19200,
    38400,
    57600,
    115200
];
function $e3d6ee63ed1479b9$var$renderDisconnected(pairedDevices, settings) {
    const pairedListHtml = pairedDevices.length > 0 ? `
      <div class="paired-devices">
        <h2>${(0, $da488e969ff3960b$export$625550452a3fa3ec)('disconnected.previouslyConnected')}</h2>
        <ul class="device-list">
          ${pairedDevices.map((d, i)=>`
            <li class="device-item" data-device-index="${i}">
              <div class="device-info-compact">
                <span class="device-name">${d.productName}</span>
                <span class="device-manufacturer">${d.manufacturer}</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </li>
          `).join('')}
        </ul>
      </div>
    ` : '';
    const baudOptionsHtml = $e3d6ee63ed1479b9$var$CONNECTION_BAUD_OPTIONS.map((rate)=>`<option value="${rate}" ${rate === settings.baudRate ? 'selected' : ''}>${rate}</option>`).join('');
    return `
    <div class="fields-column">
      <h1>${(0, $da488e969ff3960b$export$625550452a3fa3ec)('app.title')}</h1>
      <div class="form-group">
        <label for="connection-baud-rate">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('disconnected.connectionBaudRate')}</label>
        <select id="connection-baud-rate">
          ${baudOptionsHtml}
        </select>
      </div>
      ${pairedListHtml}
      <div class="connect-actions">
        <button id="connect-btn" class="btn btn-primary">
          <span class="btn-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 8a6 6 0 0 1 12 0v4a6 6 0 0 1-12 0V8z"/>
              <path d="M12 14v6"/>
              <path d="M8 20h8"/>
            </svg>
          </span>
          ${(0, $da488e969ff3960b$export$625550452a3fa3ec)('disconnected.connectNewDevice')}
        </button>
      </div>
    </div>
  `;
}
function $e3d6ee63ed1479b9$var$renderField(config, field) {
    const currentValue = config.get(field.register);
    const value = currentValue !== undefined ? currentValue : field.defaultValue;
    switch(field.type){
        case 'text':
            return $e3d6ee63ed1479b9$var$renderTextField(field, value);
        case 'number':
            return $e3d6ee63ed1479b9$var$renderNumberField(field, value);
        case 'select':
            return $e3d6ee63ed1479b9$var$renderSelectField(field, value);
        case 'checkbox':
            return $e3d6ee63ed1479b9$var$renderCheckboxField(field, value);
    }
}
function $e3d6ee63ed1479b9$var$renderTextField(field, value) {
    return `
    <div class="form-group">
      <label for="${field.register}">${(0, $da488e969ff3960b$export$625550452a3fa3ec)(field.name)}</label>
      <input
        type="text"
        id="${field.register}"
        placeholder="${field.placeholder ? (0, $da488e969ff3960b$export$625550452a3fa3ec)(field.placeholder) : ''}"
        value="${value}"
      >
    </div>
  `;
}
function $e3d6ee63ed1479b9$var$renderNumberField(field, value) {
    return `
    <div class="form-group">
      <label for="${field.register}">${(0, $da488e969ff3960b$export$625550452a3fa3ec)(field.name)}</label>
      <input
        type="number"
        id="${field.register}"
        min="${field.min ?? 0}"
        max="${field.max ?? 100}"
        step="${field.step ?? 1}"
        value="${value}"
      >
    </div>
  `;
}
function $e3d6ee63ed1479b9$var$renderSelectField(field, value) {
    const optionsHtml = field.options.map((opt)=>`<option value="${opt.value}" ${opt.value === value ? 'selected' : ''}>${(0, $da488e969ff3960b$export$625550452a3fa3ec)(opt.label)}</option>`).join('');
    return `
    <div class="form-group">
      <label for="${field.register}">${(0, $da488e969ff3960b$export$625550452a3fa3ec)(field.name)}</label>
      <select id="${field.register}">
        ${optionsHtml}
      </select>
    </div>
  `;
}
function $e3d6ee63ed1479b9$var$renderCheckboxField(field, value) {
    return `
    <div class="form-group checkbox">
      <label for="${field.register}">${(0, $da488e969ff3960b$export$625550452a3fa3ec)(field.name)}</label>
      <input
        type="checkbox"
        id="${field.register}"
        ${value ? 'checked' : ''}
      >
    </div>
  `;
}
function $e3d6ee63ed1479b9$var$renderConnecting() {
    return `
    <div class="fields-column">
      <h1>${(0, $da488e969ff3960b$export$625550452a3fa3ec)('app.title')}</h1>
      <div class="connecting-state">
        <div class="spinner"></div>
        <p class="connecting-text">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connecting.selectDevice')}</p>
      </div>
    </div>
  `;
}
function $e3d6ee63ed1479b9$var$renderError(message) {
    return `
    <div class="fields-column">
      <h1>${(0, $da488e969ff3960b$export$625550452a3fa3ec)('app.title')}</h1>
      <div class="error-state">
        <div class="error-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <p class="error-message">${message}</p>
        <button id="retry-btn" class="btn btn-secondary">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('error.tryAgain')}</button>
        <button id="back-btn" class="btn btn-outline">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('error.back')}</button>
      </div>
    </div>
  `;
}
function $e3d6ee63ed1479b9$var$renderConnected(config, deviceInfo) {
    const fieldsHtml = (0, $b721319b8fa56275$export$722479723a3a439b).map((field)=>$e3d6ee63ed1479b9$var$renderField(config, field)).join('');
    return `
    <div class="fields-column">
      <div class="device-info">
        <span class="device-status connected-badge">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.status')}</span>
        <span class="device-name">${deviceInfo.name}</span>
        <span class="device-manufacturer">${deviceInfo.manufacturer}</span>
      </div>
      <div class="serial-input-group">
        <input type="text" id="serial-input" placeholder="${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.serialPlaceholder')}">
        <button id="serial-send-btn" class="btn btn-outline">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.send')}</button>
      </div>
      ${fieldsHtml}
    </div>
    <div class="help-column">
      <p id="help-text">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.helpText')}</p>
    </div>
    <div class="action-bar">
      <button id="disconnect-btn" class="btn btn-outline">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.disconnect')}</button>
      <div class="action-spacer"></div>
      <button id="export-btn" class="btn btn-secondary">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.exportToFile')}</button>
      <button id="save-btn" class="btn btn-primary">${(0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.saveToDevice')}</button>
    </div>
  `;
}
function $e3d6ee63ed1479b9$export$b3890eb0ae9dca99(app) {
    let html;
    switch(app.state){
        case 'disconnected':
            html = $e3d6ee63ed1479b9$var$renderDisconnected(app.pairedDevices, app.connectionSettings);
            break;
        case 'connecting':
            html = $e3d6ee63ed1479b9$var$renderConnecting();
            break;
        case 'error':
            html = $e3d6ee63ed1479b9$var$renderError(app.error ?? 'An unknown error occurred');
            break;
        case 'connected':
            html = $e3d6ee63ed1479b9$var$renderConnected(app.config, app.deviceInfo);
            break;
    }
    app.elements.app.innerHTML = html;
}



/// <reference types="w3c-web-usb" />
function $711b990ff1262ca6$var$getEndpointNumbers(device) {
    const config = device.configuration;
    if (!config) return {
        in: null,
        out: null
    };
    const iface = config.interfaces[0];
    const altSetting = iface.alternate;
    let endpointIn = null;
    let endpointOut = null;
    for (const ep of altSetting.endpoints)if (ep.type === 'bulk') {
        if (ep.direction === 'in' && endpointIn === null) endpointIn = ep.endpointNumber;
        else if (ep.direction === 'out' && endpointOut === null) endpointOut = ep.endpointNumber;
    }
    return {
        in: endpointIn,
        out: endpointOut
    };
}
async function $711b990ff1262ca6$export$b71084e06a60a7e6(device, endpointOut, data) {
    const encoded = new TextEncoder().encode(data + '\n');
    await Promise.race([
        device.transferOut(endpointOut, encoded),
        new Promise((_, reject)=>setTimeout(()=>reject(new Error(`transferOut(endpoint ${endpointOut}) timed out after 5s`)), 5000))
    ]);
}
async function $711b990ff1262ca6$export$c158a93718c1825(device, endpointIn) {
    const result = await Promise.race([
        device.transferIn(endpointIn, 256),
        new Promise((_, reject)=>setTimeout(()=>reject(new Error(`transferIn(endpoint ${endpointIn}) timed out after 5s`)), 5000))
    ]);
    if (!result.data) return '';
    return new TextDecoder().decode(result.data);
}
function $711b990ff1262ca6$export$6f6e0ce61c501a5f(device) {
    const endpoints = $711b990ff1262ca6$var$getEndpointNumbers(device);
    return endpoints.out;
}
function $711b990ff1262ca6$export$897d7774eda22e43(device) {
    const endpoints = $711b990ff1262ca6$var$getEndpointNumbers(device);
    return endpoints.in;
}
async function $711b990ff1262ca6$export$3d4c04ed49431392(device, endpointOut, endpointIn, cmd, responseTimeoutMs = 2000) {
    // Send command
    const encoded = new TextEncoder().encode(cmd + '\n');
    await Promise.race([
        device.transferOut(endpointOut, encoded),
        new Promise((_, reject)=>setTimeout(()=>reject(new Error('transferOut timed out after 5s')), 5000))
    ]);
    // Read all response lines
    let result = '';
    const deadline = Date.now() + responseTimeoutMs;
    while(Date.now() < deadline)try {
        const readResult = await Promise.race([
            device.transferIn(endpointIn, 1024),
            new Promise((_, reject)=>setTimeout(()=>reject(new Error('read timeout')), 500))
        ]);
        if (!readResult.data || readResult.data.byteLength === 0) break; // No more data
        const text = new TextDecoder().decode(readResult.data);
        result += text;
        console.log('[USB-Serial RX]', text);
    } catch  {
        break;
    }
    return result.replace(/\r/g, '');
}
async function $711b990ff1262ca6$export$664b78e1bd867de9(device, commands) {
    const endpoints = $711b990ff1262ca6$var$getEndpointNumbers(device);
    if (endpoints.out === null) return false;
    for (const cmd of commands){
        if (cmd.startsWith('#')) continue;
        await $711b990ff1262ca6$export$b71084e06a60a7e6(device, endpoints.out, cmd);
    }
    return true;
}


/// <reference types="w3c-web-usb" />
const $bef8b89558c72840$var$CDC_SET_LINE_CODING = 0x20;
const $bef8b89558c72840$var$CDC_SET_CONTROL_LINE_STATE = 0x22;
// Retry configuration
const $bef8b89558c72840$var$MAX_RETRIES = 3;
const $bef8b89558c72840$var$RETRY_DELAY_MS = 500;
const $bef8b89558c72840$var$OPERATION_TIMEOUT_MS = 5000;
async function $bef8b89558c72840$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $bef8b89558c72840$var$withTimeout(promise, timeoutMs = $bef8b89558c72840$var$OPERATION_TIMEOUT_MS, operationName) {
    return Promise.race([
        promise,
        new Promise((_, reject)=>setTimeout(()=>reject(new Error(`${operationName} timed out after ${timeoutMs}ms`)), timeoutMs))
    ]);
}
async function $bef8b89558c72840$var$withRetry(operation, maxRetries = $bef8b89558c72840$var$MAX_RETRIES, operationName) {
    let lastError;
    for(let attempt = 0; attempt < maxRetries; attempt++)try {
        return await operation(attempt);
    } catch (error) {
        lastError = error;
        console.warn(`[USB-Retry] ${operationName} attempt ${attempt + 1}/${maxRetries} failed:`, error);
        if (attempt < maxRetries - 1) {
            // Exponential backoff: 500ms, 1000ms, 2000ms...
            const delay = $bef8b89558c72840$var$RETRY_DELAY_MS * Math.pow(2, attempt);
            console.log(`[USB-Retry] Retrying in ${delay}ms...`);
            await $bef8b89558c72840$var$sleep(delay);
        }
    }
    throw new Error(`${operationName} failed after ${maxRetries} attempts: ${lastError?.message}`);
}
async function $bef8b89558c72840$var$setLineCoding(device, interfaceIndex, baudRate) {
    const data = new ArrayBuffer(7);
    const view = new DataView(data);
    view.setUint32(0, baudRate, true);
    view.setUint8(4, 0); // stop bits: 1
    view.setUint8(5, 0); // parity: none
    view.setUint8(6, 8); // data bits: 8
    await device.controlTransferOut({
        requestType: 'class',
        recipient: 'interface',
        request: $bef8b89558c72840$var$CDC_SET_LINE_CODING,
        value: 0,
        index: interfaceIndex
    }, data);
}
async function $bef8b89558c72840$var$setControlLineState(device, interfaceIndex, dtr, rts) {
    const value = (dtr ? 1 : 0) | (rts ? 2 : 0);
    await device.controlTransferOut({
        requestType: 'class',
        recipient: 'interface',
        request: $bef8b89558c72840$var$CDC_SET_CONTROL_LINE_STATE,
        value: value,
        index: interfaceIndex
    });
}
async function $bef8b89558c72840$export$5841854fa89e1033(device) {
    if (!device || !device.opened) return;
    try {
        const config = device.configuration;
        if (config) {
            for(let i = 0; i < config.interfaces.length; i++)try {
                await device.releaseInterface(i);
                console.log(`[USB] Released interface ${i}`);
            } catch  {
            // Ignore release errors
            }
        }
    } catch  {
    // Ignore errors during release
    }
    try {
        await device.close();
        console.log('[USB] Device closed');
    } catch  {
    // Ignore close errors
    }
}
function $bef8b89558c72840$export$d5565557cebe8092() {
    return typeof navigator !== 'undefined' && 'usb' in navigator;
}
async function $bef8b89558c72840$export$bb5acfd49468b4c8() {
    if (!$bef8b89558c72840$export$d5565557cebe8092()) return [];
    try {
        const devices = await navigator.usb.getDevices();
        return devices.map((d)=>({
                device: d,
                productName: d.productName ?? 'Unknown Device',
                manufacturer: d.manufacturerName ?? 'Unknown'
            }));
    } catch (error) {
        console.error('[USB] Failed to get paired devices:', error);
        return [];
    }
}
const $bef8b89558c72840$var$CONNECTION_BAUD_OPTIONS = [
    9600,
    19200,
    38400,
    57600,
    115200
];
// Serial reading loop - continuously reads and logs all incoming data
let $bef8b89558c72840$var$serialReadingActive = false;
let $bef8b89558c72840$var$serialReadRetryCount = 0;
const $bef8b89558c72840$var$MAX_SERIAL_READ_RETRIES = 5;
async function $bef8b89558c72840$var$startSerialReadingLoop(device) {
    const config = device.configuration;
    if (!config || config.interfaces.length === 0) {
        console.warn('[USB-Serial] No interfaces available for serial reading');
        return;
    }
    // Find the data interface and bulk IN endpoint
    let dataInterfaceIndex = 0;
    let endpointIn = null;
    // Search all interfaces for bulk IN endpoints
    for(let i = 0; i < config.interfaces.length; i++){
        const iface = config.interfaces[i];
        for (const ep of iface.alternate.endpoints)if (ep.type === 'bulk' && ep.direction === 'in') {
            endpointIn = ep.endpointNumber;
            dataInterfaceIndex = i;
            break;
        }
        if (endpointIn !== null) break;
    }
    if (endpointIn === null) {
        console.warn('[USB-Serial] No bulk IN endpoint found');
        return;
    }
    console.log(`[USB-Serial] Starting read loop on interface ${dataInterfaceIndex}, endpoint ${endpointIn}`);
    $bef8b89558c72840$var$serialReadingActive = true;
    $bef8b89558c72840$var$serialReadRetryCount = 0;
    // Read loop
    while($bef8b89558c72840$var$serialReadingActive && device.opened)try {
        const result = await Promise.race([
            device.transferIn(endpointIn, 64),
            new Promise((_, reject)=>setTimeout(()=>reject(new Error('transferIn timeout')), 1000))
        ]);
        // Reset retry count on successful read
        $bef8b89558c72840$var$serialReadRetryCount = 0;
        if (result.data && result.data.byteLength > 0) {
            const decoder = new TextDecoder();
            const text = decoder.decode(result.data);
            console.log('[USB-Serial RX]', text);
        }
    } catch (err) {
        if (err instanceof Error && err.message === 'transferIn timeout') continue;
        if (!device.opened) {
            console.log('[USB-Serial] Device closed, stopping read loop');
            break;
        }
        $bef8b89558c72840$var$serialReadRetryCount++;
        console.error(`[USB-Serial] Read error (attempt ${$bef8b89558c72840$var$serialReadRetryCount}/${$bef8b89558c72840$var$MAX_SERIAL_READ_RETRIES}):`, err);
        if ($bef8b89558c72840$var$serialReadRetryCount >= $bef8b89558c72840$var$MAX_SERIAL_READ_RETRIES) {
            console.error('[USB-Serial] Too many read errors, stopping read loop');
            break;
        }
        // Exponential backoff before retry: 100ms, 200ms, 400ms...
        const delay = 100 * Math.pow(2, $bef8b89558c72840$var$serialReadRetryCount - 1);
        console.log(`[USB-Serial] Retrying in ${delay}ms...`);
        await new Promise((resolve)=>setTimeout(resolve, delay));
    }
    console.log('[USB-Serial] Read loop stopped');
}
async function $bef8b89558c72840$export$18e77cadae3886bf(device, baudRate, onDisconnect) {
    console.log('[USB] Opening device:', {
        productName: device.productName,
        manufacturerName: device.manufacturerName,
        vendorId: device.vendorId.toString(16).padStart(4, '0'),
        productId: device.productId.toString(16).padStart(4, '0'),
        opened: device.opened,
        configured: device.configuration !== null
    });
    // Step 1: Ensure device is in a clean state
    if (device.opened) {
        console.warn('[USB] Device is already opened. Attempting to close first...');
        await $bef8b89558c72840$export$5841854fa89e1033(device);
        // Small delay to allow the OS to process the close
        await $bef8b89558c72840$var$sleep(100);
    }
    // Step 2: Open device with retry
    await $bef8b89558c72840$var$withRetry(async ()=>{
        await device.open();
        console.log('[USB] Device opened successfully');
    }, $bef8b89558c72840$var$MAX_RETRIES, 'openDevice');
    // Step 3: Select configuration
    try {
        if (device.configuration === null) {
            console.log('[USB] Selecting configuration 1...');
            // Try to select configuration 1, but also try configuration 0 if that fails
            try {
                await $bef8b89558c72840$var$withTimeout(device.selectConfiguration(1), $bef8b89558c72840$var$OPERATION_TIMEOUT_MS, 'selectConfiguration(1)');
            } catch  {
                console.warn('[USB] Failed to select configuration 1, trying configuration 0...');
                try {
                    await $bef8b89558c72840$var$withTimeout(device.selectConfiguration(0), $bef8b89558c72840$var$OPERATION_TIMEOUT_MS, 'selectConfiguration(0)');
                } catch  {
                    throw new Error('Failed to select any configuration');
                }
            }
            console.log('[USB] Configuration selected');
        } else console.log('[USB] Device already configured');
    } catch (error) {
        console.error('[USB] Failed to select configuration:', error);
        await $bef8b89558c72840$export$5841854fa89e1033(device);
        throw error;
    }
    const ifaceConfig = device.configuration;
    console.log(`[USB] Device has ${ifaceConfig.interfaces.length} interface(s) in configuration`);
    // Step 4: Claim all interfaces with improved error handling
    const claimedInterfaces = [];
    try {
        for(let i = 0; i < ifaceConfig.interfaces.length; i++){
            const iface = ifaceConfig.interfaces[i];
            console.log('[USB] Interface', i, ':', {
                interfaceNumber: iface.interfaceNumber,
                claimed: iface.claimed,
                alternates: iface.alternates.length
            });
            if (!iface.claimed) {
                console.log(`[USB] Claiming interface ${i}...`);
                try {
                    await $bef8b89558c72840$var$withTimeout(device.claimInterface(i), $bef8b89558c72840$var$OPERATION_TIMEOUT_MS, `claimInterface(${i})`);
                    claimedInterfaces.push(i);
                    console.log(`[USB] Interface ${i} claimed successfully`);
                } catch (claimError) {
                    console.error(`[USB] Failed to claim interface ${i}:`, claimError);
                    const errorMsg = claimError?.message || '';
                    const isKernelDriverError = errorMsg.includes('kernel') || errorMsg.includes('busy') || errorMsg.toLowerCase().includes('denied');
                    if (isKernelDriverError) {
                        const vid = device.vendorId.toString(16).padStart(4, '0');
                        const pid = device.productId.toString(16).padStart(4, '0');
                        console.error(`[USB] A kernel driver (likely cdc_acm) is holding this interface.
  Solutions:
    1. Create a udev rule to give your user access:
       echo 'SUBSYSTEM=="usb", ATTR{idVendor}=="${vid}", ATTR{idProduct}=="${pid}", MODE="0666", GROUP="plugdev"' | sudo tee /etc/udev/rules.d/99-webusb.rules
       sudo udevadm control --reload-rules && sudo udevadm trigger
    2. Unplug and replug the device after creating the rule
    3. Close any other applications using this device
    4. On Windows, ensure no COM port driver is bound to this device`);
                    }
                    throw claimError;
                }
            }
        }
    } catch (error) {
        console.error('[USB] Failed to claim interfaces, cleaning up...');
        await $bef8b89558c72840$export$5841854fa89e1033(device);
        throw error;
    }
    // Step 5: Configure CDC-ACM parameters
    // Use the first interface for CDC control (interface 0 is typically the control interface)
    const interfaceNumber = ifaceConfig.interfaces[0].interfaceNumber;
    try {
        console.log('[USB] Setting line coding, baudRate:', baudRate);
        await $bef8b89558c72840$var$withTimeout($bef8b89558c72840$var$setLineCoding(device, interfaceNumber, baudRate), $bef8b89558c72840$var$OPERATION_TIMEOUT_MS, 'setLineCoding');
        console.log('[USB] Line coding set successfully');
        console.log('[USB] Setting control line state (DTR=true, RTS=true)...');
        await $bef8b89558c72840$var$withTimeout($bef8b89558c72840$var$setControlLineState(device, interfaceNumber, true, true), $bef8b89558c72840$var$OPERATION_TIMEOUT_MS, 'setControlLineState');
        console.log('[USB] Control line state set successfully');
    } catch (error) {
        console.error('[USB] Failed to configure CDC-ACM parameters:', error);
        await $bef8b89558c72840$export$5841854fa89e1033(device);
        throw error;
    }
    console.log('[USB] Device setup complete');
    // Step 6: Set up disconnect monitoring
    const disconnectHandler = (event)=>{
        if (event.device === device) {
            console.log('[USB] Device disconnected');
            onDisconnect();
        }
    };
    navigator.usb.addEventListener('disconnect', disconnectHandler);
    // Store the handler reference on the device for cleanup
    device.__usbDisconnectHandler = disconnectHandler;
    // Step 7: Start serial data reading loop
    $bef8b89558c72840$var$startSerialReadingLoop(device);
    return {
        name: device.productName ?? 'Unknown Device',
        manufacturer: device.manufacturerName ?? 'Unknown'
    };
}
async function $bef8b89558c72840$export$c9f30ed68f5ad7e5(device) {
    console.log('[USB] Closing device...');
    // Stop serial reading loop
    $bef8b89558c72840$var$serialReadingActive = false;
    // Remove the disconnect handler we added to navigator.usb
    const disconnectHandler = device.__usbDisconnectHandler;
    if (disconnectHandler) {
        navigator.usb.removeEventListener('disconnect', disconnectHandler);
        delete device.__usbDisconnectHandler;
    }
    // Use safeRelease to properly clean up all interfaces
    await $bef8b89558c72840$export$5841854fa89e1033(device);
    console.log('[USB] Device closed');
}


const $b4e14b6b8da86996$var$DEFAULT_BAUD_RATE = 115200;
function $b4e14b6b8da86996$var$createApp() {
    return {
        state: 'disconnected',
        config: (0, $0266756030f09424$export$62b110e0dc0699c4)(),
        elements: {},
        error: null,
        deviceInfo: null,
        pairedDevices: [],
        connectionSettings: {
            baudRate: $b4e14b6b8da86996$var$DEFAULT_BAUD_RATE
        },
        usbDevice: null,
        onDeviceDisconnect: null
    };
}
function $b4e14b6b8da86996$var$init() {
    const app = $b4e14b6b8da86996$var$createApp();
    app.elements.app = document.getElementById('app');
    // Load paired devices on init
    if ((0, $bef8b89558c72840$export$d5565557cebe8092)()) (0, $bef8b89558c72840$export$bb5acfd49468b4c8)().then((devices)=>{
        app.pairedDevices = devices;
        if (app.state === 'disconnected') (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
    });
    async function connectToDevice(device) {
        app.state = 'connecting';
        (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
        try {
            const info = await (0, $bef8b89558c72840$export$18e77cadae3886bf)(device, app.connectionSettings.baudRate, ()=>{
                app.state = 'disconnected';
                app.usbDevice = null;
                app.deviceInfo = null;
                app.onDeviceDisconnect = null;
                (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
            });
            app.state = 'connected';
            app.usbDevice = device;
            app.deviceInfo = info;
            (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
        } catch (err) {
            const error = err;
            app.state = 'error';
            app.error = error.message;
            (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
        }
    }
    async function connectNewDevice() {
        if (!(0, $bef8b89558c72840$export$d5565557cebe8092)()) {
            app.state = 'error';
            app.error = (0, $da488e969ff3960b$export$625550452a3fa3ec)('errors.webusbNotSupported');
            (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
            return;
        }
        app.state = 'connecting';
        (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
        try {
            const device = await navigator.usb.requestDevice({
                filters: []
            });
            await connectToDevice(device);
        } catch (err) {
            const error = err;
            if (error.name === 'NotFoundError') {
                app.state = 'error';
                app.error = (0, $da488e969ff3960b$export$625550452a3fa3ec)('errors.noDeviceSelected');
            } else if (error.name === 'SecurityError') {
                app.state = 'error';
                app.error = (0, $da488e969ff3960b$export$625550452a3fa3ec)('errors.permissionDenied');
            } else {
                app.state = 'error';
                app.error = (0, $da488e969ff3960b$export$625550452a3fa3ec)('errors.failedToOpen', {
                    error: error.message
                });
            }
            (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
        }
    }
    app.elements.app.addEventListener('click', async (e)=>{
        const target = e.target;
        const deviceItem = target.closest('[data-device-index]');
        if (deviceItem) {
            const index = parseInt(deviceItem.dataset.deviceIndex, 10);
            const device = app.pairedDevices[index]?.device;
            if (device) await connectToDevice(device);
        } else if (target.id === 'connect-btn' || target.closest('#connect-btn')) await connectNewDevice();
        else if (target.id === 'retry-btn') await connectNewDevice();
        else if (target.id === 'back-btn') {
            app.state = 'disconnected';
            app.error = null;
            (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
        } else if (target.id === 'disconnect-btn') {
            if (app.usbDevice && app.onDeviceDisconnect) await (0, $bef8b89558c72840$export$c9f30ed68f5ad7e5)(app.usbDevice);
            app.usbDevice = null;
            app.onDeviceDisconnect = null;
            app.state = 'disconnected';
            app.deviceInfo = null;
            (0, $bef8b89558c72840$export$bb5acfd49468b4c8)().then((devices)=>{
                app.pairedDevices = devices;
                (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
            });
        } else if (target.id === 'serial-send-btn') {
            const input = document.getElementById('serial-input');
            if (input && input.value && app.usbDevice) {
                const endpointOut = (0, $711b990ff1262ca6$export$6f6e0ce61c501a5f)(app.usbDevice);
                const endpointIn = (0, $711b990ff1262ca6$export$897d7774eda22e43)(app.usbDevice);
                if (endpointOut !== null && endpointIn !== null) {
                    const response = await (0, $711b990ff1262ca6$export$3d4c04ed49431392)(app.usbDevice, endpointOut, endpointIn, input.value);
                    console.log('[CLI] Response:', response);
                }
                input.value = '';
            }
        } else if (target.id === 'save-btn') {
            if (!app.usbDevice) {
                alert((0, $da488e969ff3960b$export$625550452a3fa3ec)('alerts.noDevice'));
                return;
            }
            const saveBtn = target;
            saveBtn.disabled = true;
            saveBtn.textContent = (0, $da488e969ff3960b$export$625550452a3fa3ec)('alerts.saving');
            try {
                const success = await (0, $711b990ff1262ca6$export$664b78e1bd867de9)(app.usbDevice, (0, $0266756030f09424$export$a5bc101ffe200192)(app.config));
                if (success) alert((0, $da488e969ff3960b$export$625550452a3fa3ec)('alerts.saveSuccess'));
                else alert((0, $da488e969ff3960b$export$625550452a3fa3ec)('alerts.saveFailure'));
            } catch (err) {
                const error = err;
                alert((0, $da488e969ff3960b$export$625550452a3fa3ec)('alerts.saveError', {
                    error: error.message
                }));
            } finally{
                saveBtn.disabled = false;
                saveBtn.textContent = (0, $da488e969ff3960b$export$625550452a3fa3ec)('connected.saveToDevice');
            }
        } else if (target.id === 'export-btn') {
            const textContent = (0, $0266756030f09424$export$2d002c582c9ee89e)(app.config);
            const blob = new Blob([
                textContent
            ], {
                type: 'text/plain'
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'device-config.txt';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    });
    app.elements.app.addEventListener('input', (e)=>{
        const target = e.target;
        if (target.id === 'connection-baud-rate') {
            app.connectionSettings.baudRate = Number(target.value);
            return;
        }
        if (target.id) {
            const newApp = (0, $0621848b4c472bdf$export$cec8daecec400388)(app, target.id, target.value);
            app.config = newApp.config;
        }
    });
    app.elements.app.addEventListener('change', (e)=>{
        const target = e.target;
        if (target.type === 'checkbox' && target.id) {
            const newApp = (0, $0621848b4c472bdf$export$cec8daecec400388)(app, target.id, String(target.checked));
            app.config = newApp.config;
        }
    });
    app.elements.app.addEventListener('keydown', async (e)=>{
        const target = e.target;
        if (target.id === 'serial-input' && e.key === 'Enter') {
            const sendBtn = document.getElementById('serial-send-btn');
            if (sendBtn) sendBtn.click();
        }
    });
    app.elements.app.addEventListener('focusin', (e)=>{
        const target = e.target;
        if (target.id && target.closest('.form-group') && target.id !== 'connection-baud-rate') {
            const fieldConfig = (0, $b721319b8fa56275$export$722479723a3a439b).find((f)=>f.register === target.id);
            const helpText = document.getElementById('help-text');
            if (helpText && fieldConfig) helpText.textContent = (0, $da488e969ff3960b$export$625550452a3fa3ec)(fieldConfig.help);
        }
    });
    app.elements.app.addEventListener('focusout', (e)=>{
        const target = e.target;
        if (target.id && target.closest('.form-group') && target.id !== 'connection-baud-rate') {
            const helpText = document.getElementById('help-text');
            if (helpText) helpText.textContent = (0, $da488e969ff3960b$export$625550452a3fa3ec)('help.default');
        }
    });
    (0, $e3d6ee63ed1479b9$export$b3890eb0ae9dca99)(app);
}
$b4e14b6b8da86996$var$init();


//# sourceMappingURL=pmc-web.ce8fae1e.js.map
